var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"desig-main"},[(_vm.showOne)?_c('airconditioner'):_vm._e(),_vm._v(" "),(_vm.showTwo)?_c('refrigeration'):_vm._e(),_vm._v(" "),(_vm.showscene)?_c('sceneshow'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ce169ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/designtoolpages/TheMain.vue
// module id = null
// module chunks = 